import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { objectFitCoverImageStyles, SDUIImage } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { getCssAlignmentValue } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/getCssAlignmentValue";
import { convertServerResponsivePropertyToClientResponsiveProperty, getResponsiveValueAtIndex } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import * as styles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/AnnouncementBannerRenderer/styles/SDUIAnnouncementBannerRenderer.css";
import { ANNOUNCEMENT_BANNER_HEIGHTS } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/AnnouncementBannerRenderer/styles/SDUIAnnouncementBannerRenderer.css";
import { SDUIBannerTextContent } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/BannerTextContent/SDUIBannerTextContent";
import { Column } from "@faire/web--source/slate/Layout";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";
var OPTIMIZE_IMAGE_OPTIONS = {
    mobileAndAbove: {
        height: ANNOUNCEMENT_BANNER_HEIGHTS.mobileAndAbove
    },
    tabletAndAbove: {
        height: ANNOUNCEMENT_BANNER_HEIGHTS.tabletAndAbove
    },
    desktopAndAbove: {
        height: ANNOUNCEMENT_BANNER_HEIGHTS.desktopAndAbove
    }
};
export var SDUIDefaultAnnouncementBannerRenderer = function(props) {
    return /*#__PURE__*/ _jsx(BaseSDUIAnnouncementBannerRenderer, _object_spread_props(_object_spread({}, props), {
        variant: "standard"
    }));
};
export var SDUIConstrainedWidthAnnouncementBannerRenderer = function(props) {
    return /*#__PURE__*/ _jsx(BaseSDUIAnnouncementBannerRenderer, _object_spread_props(_object_spread({}, props), {
        variant: "constrained"
    }));
};
var BaseSDUIAnnouncementBannerRenderer = function(param) {
    var bannerComponent = param.bannerComponent, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour, variant = param.variant;
    var images = bannerComponent.images, responsive_images = bannerComponent.responsive_images, vertical_content_alignment = bannerComponent.vertical_content_alignment;
    var responsiveImages = convertServerResponsivePropertyToClientResponsiveProperty(images, function(img) {
        return img;
    }, responsive_images);
    return /*#__PURE__*/ _jsxs(Column, {
        className: classNames(styles.announcementBannerWrapper),
        style: assignInlineVars(_define_property({}, styles.verticalContentAlignment, "".concat(getCssAlignmentValue(vertical_content_alignment, "center")))),
        children: [
            /*#__PURE__*/ _jsx(SDUIImage, {
                responsiveImage: getResponsiveValueAtIndex(responsiveImages, 0, IImage.build()),
                optimizeImageOptions: OPTIMIZE_IMAGE_OPTIONS,
                renderBehaviour: renderBehaviour,
                className: styles.backgroundImageWrapper,
                imageStyles: objectFitCoverImageStyles
            }),
            /*#__PURE__*/ _jsx(SDUIBannerTextContent, {
                className: classNames(styles.announcementBannerContent, variant === "constrained" ? styles.constrainedWidthContent : styles.standardWidthContent),
                bannerComponent: bannerComponent,
                loggingData: loggingData
            })
        ]
    });
};
